
import {map,  tap } from 'rxjs/operators';
/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/


import { AppUtilityService } from './app-utility.service';
import { AuthenticatedUser } from './../model/authenticated-user.model';
import { ConfigService } from './config.service';
import { Injectable } from '@angular/core';
import { LmsLoggerService } from './lms-logger.service';
import { MessageDetails } from '../model/message-details.model';
import { MessageHandlerService } from './message-handler.service';
import { StaticDataStoreService } from './../services/static-datastore.service';
import { UserProfile } from './../model/user-profile.model';
import { UserService } from './user.service';
import { UtilService } from './util.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

/**
 * @export
 * @class UserProfileService
 */
@Injectable()
export class UserProfileService {

  private RESOURCE_URL = '/user/preferences/';
  private APPLY_SETTING_URL = 'add';
  private UPDATE_SETTING_URL = 'update';
  user: AuthenticatedUser;
  subscription: any;
  private configData: any;

  /**
   * Creates an instance of UserProfileService.
   * @param {HttpClient} http
   * @param {ConfigService} configService
   * @param {UserService} userService
   * @param {UtilService} utilService
   * @param {StaticDataStoreService} staticDataStoreService
   * @param {MessageHandlerService} messageHandlerService
   * @param {LmsLoggerService} lmsLoggerService
   *
   * @memberOf UserProfileService
   */
  constructor(private http: HttpClient,
    private configService: ConfigService,
    private userService: UserService,
    private utilService: UtilService,
    private staticDataStoreService: StaticDataStoreService,
    private messageHandlerService: MessageHandlerService,
    private appUtilityService: AppUtilityService,
    private lmsLoggerService: LmsLoggerService) {
    this.configData = this.configService.getConfigData();
  }

  /**
   * Set response from user profile service in to staticDataStoreService.
   * @param {any} response
   * @memberOf UserProfileService
   */
  load(response) {
    const userProfile = <UserProfile>(response);
    this.staticDataStoreService.putValue('userProfile', userProfile);
    this.lmsLoggerService.logInfo('UserProfileService => load()', `User Profile Data Fetch Successfull for ${JSON.stringify(userProfile)}`);
  }

  /**
   * Handle error occuured during retrieve user profile data from service.
   * @param {any} error
   * @memberOf UserProfileService
   */
  handleError(error) {
    this.messageHandlerService.handleMessage(<MessageDetails>({
      type: this.configService.getConfigData().message.type.server,
      level: this.configService.getConfigData().message.level.error,
      target: this.configService.getConfigData().message.target.page,
      message: this.appUtilityService.getHttpErroMessage(error, false)
    }));
  }

  /**
   * Retrieve user profile from service.
   * @returns
   * @memberOf UserProfileService
   */
  getData() {
    const user = this.staticDataStoreService.getValue('user');
    this.lmsLoggerService.logInfo('UserProfileService=>getData service call starts');
    return this.http.get(`${this.configService.getConfigData().urls.API_URL}${this.RESOURCE_URL}${user.racfId}`).pipe(
      tap(() => this.lmsLoggerService.logInfo('UserProfileService=>getData service call ends'))
    );
  }

  /**
   * Invoked for add user setting.
   * @param {UserProfile} userProfile
   * @returns
   * @memberOf UserProfileService
   */
  addSetting(userProfile: UserProfile) {
    const apiUrl = this.configData.urls.API_URL;
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const options = { headers: headers };
    this.lmsLoggerService.logInfo('UserProfileService=>addSetting service call starts');
    return this.http.post(`${apiUrl}${this.RESOURCE_URL}${this.APPLY_SETTING_URL}`,
      JSON.stringify(userProfile), options).pipe(map(response => {
        this.lmsLoggerService.logInfo('UserProfileService=>addSetting service call ends');
        return response;
      }));
  }

  /**
   * Invoked for update user setting.
   * @param {UserProfile} userProfile
   * @returns
   * @memberOf UserProfileService
   */
  updateSetting(userProfile: UserProfile) {
    const apiUrl = this.configData.urls.API_URL;
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const options = { headers: headers, responseType: 'text' as 'json' };
    this.lmsLoggerService.logInfo('UserProfileService=>updateSetting service call starts');
    return this.http.post(`${apiUrl}${this.RESOURCE_URL}${this.UPDATE_SETTING_URL}`,
      JSON.stringify(userProfile), options).pipe(map(response => {
        this.lmsLoggerService.logInfo('UserProfileService=>updateSetting service call ends');
        return response;
      }));
  }
}
